import Breadcrumb from "react-bootstrap/Breadcrumb";
import _ from "lodash";
import { getData, postData } from "../../api/ApiRest";
import { useEffect, useState } from "react";
import LoadingComponent from "./../../widgets/LoadingComponent";
import { NumericFormat } from "react-number-format";
import { FaCheckCircle, FaEdit, FaRegTimesCircle, FaSave } from "react-icons/fa";
import moment from "moment";
import { Autocomplete, Container, Grid, TextField } from "@mui/material";
import { useMemo } from "react";
import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import auditoriaSet from '../../widgets/Auditoria';

function Plan() {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const groupByYear = useMemo(() => {
    return _.groupBy(plans, "periodo");
  }, [plans]);
  const currentYear = moment().year();
  const [yearSelected, setYearSelected] = useState(currentYear);

  const [infoPlanes, setInfoPlanes] = useState({
    ModalVisible: false, Titulo: '', Planid: '', Plan: {}, PlanOrigen: {}
  });

  useEffect(() => {
    setLoading(true);

    getData("api/Configuracion/Plan/Index", {}, false).then(
      (response) => {
        setPlans(response.planes);
        setLoading(false);
      },
      (error) => {
        alert("Algo salio mal al cargar los planes");
        setLoading(false);
        console.log(error);
      }
    );
  }, []);

  ///Función para guardar un plan nuevo o un edit
  const guardarInfoPlan = () => {
    setLoading(true);

    postData('api/Configuracion/Plan/guardarInfoPlan', { PlanId: infoPlanes.Planid }, {
      codProducto: infoPlanes.Plan.codProducto,
      codigo: infoPlanes.Plan.codigo,
      descripcion: infoPlanes.Plan.descripcion,
      estado: infoPlanes.Plan.estado,
      foliosAno: infoPlanes.Plan.foliosAno,
      foliosMes: infoPlanes.Plan.foliosMes,
      id: infoPlanes.Plan.id,
      periodo: infoPlanes.Plan.periodo,
      valorAno: infoPlanes.Plan.valorAno,
      valorAnoRenovacion: infoPlanes.Plan.valorAnoRenovacion,
      valorMes: infoPlanes.Plan.valorMes,
      valorMesRenovacion: infoPlanes.Plan.valorMesRenovacion
    }).then(response => {
      if (response.status) {
        alert(response.msj);

        auditoriaSet(infoPlanes.PlanOrigen, infoPlanes.Plan, 'A', 'Planes', '', 'PlanesGlobales');

        setTimeout(() => {
          if (response.status)
            window.location.reload();
        }, 500)
      }

      setLoading(false);
    }, error => {
      console.log(error);
      setLoading(false);
    })
  }

  return (
    <Container maxWidth="small" style={{ padding: "1rem " }}>
      <Grid container direction={"column"} md={12} bgcolor={""}>
        <Breadcrumb>
          <Breadcrumb.Item>Empresas</Breadcrumb.Item>
          <Breadcrumb.Item active={true}>Planes</Breadcrumb.Item>
        </Breadcrumb>

        <LoadingComponent Loading={loading} />

        <Grid md={3} bgcolor={""}>
          <Autocomplete
            options={Object.keys(groupByYear)}
            getOptionLabel={(option) => option.toString()}
            defaultValue={currentYear}
            onChange={(e, newValue) => setYearSelected(Number(newValue))}
            renderInput={(params) => (
              <TextField {...params} label="Selecciona una opción" />
            )}
          />
        </Grid>

        <div className="table-responsive mt-3">
          <table className="table table-bordered table-hover">
            <thead>
              <tr className="table-info">
                <th></th>
                <th>Periodo </th>
                <th>Codigo</th>
                <th>Descripción</th>
                <th>Folios Mensuales</th>
                <th>Folios Anuales</th>
                <th>Valor Mensual</th>
                <th>Valor Anual</th>
                <th>Valor Renovación Mensual</th>
                <th>Valor Renovación Anual</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {groupByYear[yearSelected]?.map((item, key) => (
                <tr key={item.id}>
                  <td>
                    <Button variant="primary" type="button" onClick={() => {
                      setInfoPlanes({
                        ModalVisible: true,
                        Planid: item.id,
                        Titulo: 'Editar ' + item.descripcion,
                        Plan: item,
                        PlanOrigen: item
                      });
                    }}>
                      <FaEdit size={'1rem'} />
                    </Button>
                  </td>
                  <td className="text-center">{item.periodo}</td>
                  <td className="text-center">{item.codigo}</td>
                  <td>{item.descripcion}</td>
                  <td className="text-center">
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.foliosMes}
                    />
                  </td>
                  <td className="text-center">
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.foliosAno}
                    />
                  </td>
                  <td className="text-center">
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.valorMes}
                      prefix="$"
                    />
                  </td>
                  <td className="text-center">
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.valorAno}
                      prefix="$"
                    />
                  </td>
                  <td className="text-center">
                    {" "}
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.valorMesRenovacion}
                      prefix="$"
                    />
                  </td>
                  <td className="text-center">
                    {" "}
                    <NumericFormat
                      displayType="text"
                      thousandSeparator=","
                      value={item.valorAnoRenovacion}
                      prefix="$"
                    />
                  </td>
                  <td className="text-center">
                    {item.estado === true ? (
                      <FaCheckCircle size={"1rem"} color="green" />
                    ) : (
                      <FaRegTimesCircle size={"1rem"} color="red" />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Modal
          show={infoPlanes.ModalVisible}
          size="xl"
          onHide={() => {
            setInfoPlanes({
              ModalVisible: false,
              Planid: '',
              Titulo: '',
              Plan: {},
              PlanOrigen: {}
            });
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{infoPlanes.Titulo}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-3">
                <FloatingLabel controlId="periodoNewInput" label="Periodo">
                  <Form.Control
                    as="input"
                    type='text'
                    rows={1}
                    value={infoPlanes.Plan.periodo}
                    readOnly
                  />
                </FloatingLabel>
              </div>
              <div className="col-md-3">
                <FloatingLabel
                  controlId="codigoPlan"
                  label="Codigo"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="text"
                    required={true}
                    autoComplete='off'
                    placeholder="Código"
                    value={infoPlanes.Plan.codigo}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        codigo: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
              <div className="col-md-6">
                <FloatingLabel
                  controlId="descripcionPlan"
                  label="Descripçión"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="text"
                    autoComplete='off'
                    placeholder="Descripción"
                    value={infoPlanes.Plan.descripcion}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        descripcion: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <FloatingLabel
                  controlId="foliosMensualesPlan"
                  label="Folios mensuales"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.foliosMes}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        foliosMes: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
              <div className="col-md-3">
                <FloatingLabel
                  controlId="foliosAnoPlan"
                  label="Folios año"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.foliosAno}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        foliosAno: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>

              <div className="col-md-3">
                <FloatingLabel
                  controlId="valorAñoPlan"
                  label="Vlr nuevo cliente"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.valorAno}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        valorAno: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>

              <div className="col-md-3">
                <FloatingLabel
                  controlId="valorAñoPlan"
                  label="Vlr renovación año"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.valorAnoRenovacion}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        valorAnoRenovacion: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <FloatingLabel
                  controlId="valorMensualPlan"
                  label=" Vlr plan mensual"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.valorMes}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        valorMes: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
              <div className="col-md-3">
                <FloatingLabel
                  controlId="valorAñoPlan"
                  label="Vlr mensualidad"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="number"
                    autoComplete='off'
                    value={infoPlanes.Plan.valorMesRenovacion}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        valorMesRenovacion: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>

              <div className="col-md-3">
                <FloatingLabel
                  controlId="coProductoPlan"
                  label="Cod producto"
                  className='mb-2'
                >
                  <Form.Control
                    size='sm'
                    type="text"
                    autoComplete='off'
                    value={infoPlanes.Plan.codProducto}
                    onChange={event => setInfoPlanes({
                      ...infoPlanes, Plan: {
                        ...infoPlanes.Plan,
                        codProducto: event.target.value
                      }
                    })}
                  />
                </FloatingLabel>
              </div>
              <div className="col-md-1">
                <Button variant="success" type="button" onClick={() => guardarInfoPlan()}>
                  <FaSave size={'1rem'} />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Grid>
    </Container>
  );
}

export default Plan;
